(function () {
  'use strict';

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  var ICONS = {
    spec: ['M5 3h14v18H5z', 'M9 8h6M9 12h6M9 16h4'],
    faq: ['M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z', 'M9.5 9.4a2.6 2.6 0 0 1 4.8 1.2c0 1.7-2.3 2.2-2.3 3.6', 'M12 16.6h.01'],
    manual: ['M4 4.5A2.5 2.5 0 0 1 6.5 2H20v18H6.5A2.5 2.5 0 0 0 4 22.5z', 'M8 7h8M8 11h6'],
    firmware: ['M12 3v9', 'M8.5 8.5L12 12l3.5-3.5', 'M5 16h14v4H5z'],
    driver: ['M4 11a8 8 0 0 1 16 0', 'M12 11v4', 'M9 20h6'],
    start: ['M5 19c0-5 3-12 9-14 1 4-1 9-5 12', 'M5 19l2-4 2 2z'],
    warranty: ['M12 21s7-3.5 7-9V5l-7-2.5L5 5v7c0 5.5 7 9 7 9z', 'M9 12l2 2 4-4'],
    download: ['M12 3v12', 'M7 10l5 5 5-5', 'M5 21h14']
  };
  function icon(key) {
    var paths = ICONS[key] || ICONS.spec;
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">' +
      paths.map(function (d) { return '<path d="' + d + '"></path>'; }).join('') + '</svg>';
  }

  function getHandle() {
    try { return new URLSearchParams(window.location.search).get('p') || ''; } catch (e) { return ''; }
  }

  function showNotFound() {
    document.getElementById('ps-found').hidden = true;
    document.getElementById('ps-notfound').hidden = false;
  }

  function render(data) {
    if (!data || !data.title) { showNotFound(); return; }

    document.getElementById('ps-crumb').textContent = data.title;
    document.getElementById('ps-header-bg').style.background = data.accent || '#f7f7f9';
    document.getElementById('ps-media').innerHTML = data.image
      ? '<img src="' + esc(data.image) + '" alt="' + esc(data.title) + '">'
      : '';
    document.getElementById('ps-brand').textContent = (data.vendor || '') + ' ・ Support';
    document.getElementById('ps-name').textContent = data.title;
    var taglineEl = document.getElementById('ps-tagline');
    if (data.tagline) { taglineEl.textContent = data.tagline; taglineEl.hidden = false; } else { taglineEl.hidden = true; }

    var modelNumbersEl = document.getElementById('ps-model-numbers');
    var variantModels = data.variant_models || [];
    if (variantModels.length) {
      modelNumbersEl.innerHTML = variantModels.map(function (v) {
        return esc(v.title) + ': ' + esc(v.model_number);
      }).join('<br>');
      modelNumbersEl.hidden = false;
    } else {
      modelNumbersEl.hidden = true;
    }
    document.getElementById('ps-product-link').setAttribute('href', data.url || '#');

    var resources = [
      { title: '製品仕様', desc: '詳細スペックを確認', href: data.url + '#specs', icon: 'spec' },
      { title: 'よくあるご質問', desc: 'FAQで解決方法を探す', href: data.faq_category ? ('/pages/faq?c=' + encodeURIComponent(data.faq_category)) : '/pages/faq', icon: 'faq' }
    ];
    if (data.manual_url) resources.push({ title: '取扱説明書', desc: 'PDFマニュアルを閲覧', href: data.manual_url, icon: 'manual' });
    if (data.firmware_url) {
      resources.push({ title: 'ファームウェア', desc: '最新版をダウンロード', href: data.firmware_url, icon: 'firmware' });
    } else if (data.driver_mac_url || data.driver_win_url) {
      resources.push({ title: 'ドライバー', desc: 'Mac/Windows用ドライバーを開く', href: '#downloads', icon: 'driver' });
    }
    resources.push({ title: 'スタートガイド', desc: '初期設定・使い方', icon: 'start', unavailable: true });
    resources.push({ title: '保証規定', desc: '保証内容と申請方法', href: '/pages/warranty', icon: 'warranty' });

    document.getElementById('ps-resources').innerHTML = resources.map(function (r) {
      var iconHtml = '<span class="ak-ps-resource__icon">' + icon(r.icon) + '</span><div><h3>' + esc(r.title) + '</h3><p>' + esc(r.desc) + '</p></div>';
      if (r.unavailable) return '<div class="ak-ps-resource ak-ps-resource--unavailable">' + iconHtml + '</div>';
      return '<a class="ak-ps-resource" href="' + esc(r.href) + '">' + iconHtml + '</a>';
    }).join('');

    var downloads = [];
    if (data.manual_url) downloads.push({ name: data.title + ' 取扱説明書 (PDF)', href: data.manual_url });
    if (data.driver_win_url) downloads.push({ name: 'Windows ドライバー', href: data.driver_win_url });
    if (data.driver_mac_url) downloads.push({ name: 'Mac ドライバー', href: data.driver_mac_url });
    if (data.driver_web_url) downloads.push({ name: 'Web ドライバー', href: data.driver_web_url, label: '開く' });
    if (data.firmware_url) downloads.push({ name: data.title + ' ファームウェア', href: data.firmware_url });
    if (data.keymap_url) downloads.push({ name: data.title + ' キーマップ', href: data.keymap_url });
    var dlWrap = document.getElementById('downloads');
    if (downloads.length) {
      document.getElementById('ps-downloads').innerHTML = downloads.map(function (d) {
        return '<div class="ak-ps-download-row"><span class="ak-ps-download-row__icon">' + icon('download') + '</span>' +
          '<div class="ak-ps-download-row__text"><p>' + esc(d.name) + '</p></div><a href="' + esc(d.href) + '">' + esc(d.label || 'DL') + '</a></div>';
      }).join('');
      dlWrap.hidden = false;
    } else {
      dlWrap.hidden = true;
    }

    var others = data.related || [];
    var othersWrap = document.getElementById('ps-others-wrap');
    if (others.length) {
      document.getElementById('ps-others').innerHTML = others.map(function (o) {
        return '<a class="ak-ps-other" href="/pages/product-support?p=' + encodeURIComponent(o.handle) + '">' +
          '<span class="ak-ps-other__thumb" style="background:' + esc(o.accent || '#f5f5f7') + '">' +
          (o.image ? '<img src="' + esc(o.image) + '" alt="">' : '') + '</span>' + esc(o.title) + '</a>';
      }).join('');
      othersWrap.hidden = false;
    } else {
      othersWrap.hidden = true;
    }

    document.getElementById('ps-found').hidden = false;
    document.getElementById('ps-notfound').hidden = true;
  }

  function init() {
    var handle = getHandle();
    if (!handle) { showNotFound(); return; }

    fetch('/products/' + encodeURIComponent(handle))
      .then(function (res) {
        if (!res.ok) throw new Error('product not found');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var script = doc.querySelector('[data-product-support-payload]');
        if (!script) throw new Error('support payload missing');
        render(JSON.parse(script.textContent));
      })
      .catch(function () { showNotFound(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
